const inlineRecommendationLocationStyle = {
  '.settings-grid-view .inline-recommendation-grid-icon': {
    color: '#1470A5',
    display: 'inline-block',
    overflow: 'visible',
    background: '#e6f5fa',
  },
  '.settings-grid-view .inline-recommendation-grid-icon:before': {
    fontSize: 14,
  },
};

export const allSettingsSummaryStyle = Object.assign({}, inlineRecommendationLocationStyle);
